import { changePrinter } from '../../apis/firebase';
import {
  ERROR_UPDATE_PRINTER,
  ERROR_NO_PRINTER_FOUND,
  ERROR_REQUIRED_FIELD
} from '../../constants';

export const initDataConfig = async (newProps, component) => {
  const { configurations } = newProps;
  const { printers } = configurations;
  await component.setState(prevStates => ({
    currentPrinters: printers ? printers.slice(0, 10) : prevStates.currentPrinters
  }));
};

export const handleClose = component => {
  component.setState({ addPrintModal: false, selectedPrinter: null });
};

export const handleChangePrinter = async component => {
  const { openErrorModal } = component.props;

  component.setState({ addPrintModal: true, isSearchingPrinters: true });

  const printers = await window.getCurrentPrinters();
  if (printers)
    component.setState({
      printers,
      isSearchingPrinters: false
    });
  else {
    component.setState({ addPrintModal: false, isSearchingPrinters: false });
    openErrorModal(ERROR_NO_PRINTER_FOUND);
  }
};

export const selectPrinter = async component => {
  const { openErrorModal } = component.props;
  const { printers, selectedPrinter } = component.state;
  if (!selectedPrinter) openErrorModal(ERROR_REQUIRED_FIELD);
  else {
    try {
      const printerArray = [printers[selectedPrinter]];
      component.setState({ isLoading: true });
      await changePrinter(printerArray);
    } catch (err) {
      openErrorModal(ERROR_UPDATE_PRINTER);
    }
    component.setState({ isLoading: false });
    handleClose(component);
  }
};
export const handleListItemClick = (event, index, component) => {
  component.setState({ selectedPrinter: index });
};
